import { defineStore } from 'pinia'
import { getConfig } from '@/api/app'
const useAppStore = defineStore({
    id: 'app',
    state: () => {
        return {
            config: {},
            isMobile: true,
            isCollapsed: false,
            isRouteShow: true,
            deptId: 0,
            cache: {}
        }
    },
    actions: {
        getConfig () {
            if(this.deptId * 1 > 0){
                this.setItem('dp', this.deptId)
            }else{
                if(this.getItem('dp')){
                    this.deptId = this.getItem('dp')
                }
            }
            return new Promise((resolve, reject) => {
                getConfig({'dp':this.deptId})
                    .then((data) => {
                        this.config = data
                        resolve(data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        setMobile (isMobile) {
            this.isMobile = isMobile
        },
        setCollapsed (isCollapsed) {
            this.isCollapsed = isCollapsed
        },
        setRouteShow (isRouteShow) {
            this.isRouteShow = isRouteShow
        },
        // ✅ 获取缓存数据（自动解析 JSON）
        getItem(key) {
            const storedValue = localStorage.getItem(key)
            if (storedValue) {
            try {
                // 如果是 JSON 格式，则解析成对象；否则直接返回字符串
                this.cache[key] = storedValue.startsWith('{') || storedValue.startsWith('[')
                ? JSON.parse(storedValue)
                : storedValue
                return this.cache[key]
            } catch (error) {
                console.error(`解析 ${key} 失败`, error)
                return storedValue // 如果解析失败，直接返回原字符串
            }
            }
            return null
        },  
        // ✅ 设置缓存数据（自动转换 JSON 或存为字符串）
        setItem(key, value) {
            try {
            if (typeof value === 'object') {
                // 对象数据转换成 JSON
                localStorage.setItem(key, JSON.stringify(value))
            } else {
                // 直接存字符串
                localStorage.setItem(key, value)
            }
            this.cache[key] = value
            } catch (error) {
            console.error(`存储 ${key} 失败`, error)
            }
        },
    
        // ✅ 删除指定 key 的缓存
        removeItem(key) {
            if (this.cache[key]) {
            delete this.cache[key]
            }
            localStorage.removeItem(key)
        },

        getDpId(){
            return this.deptId || this.getItem('dp') || 0
        },
        setDpId(dp){
            this.deptId = dp
            this.setItem('dp',dp)
        }
    
        // ✅ 清空所有缓存 不清空所有缓存，因为缓存中有一些是必须的 比如用户信息之类的
        /* clearAll() {
            this.cache = {}
            localStorage.clear()
        } */
    }
})
export default useAppStore



// WEBPACK FOOTER //
// ./src/stores/modules/app.js